(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const mediaPattern = /^#rn-product-media-(\d+)$/;
    const researchHash = '#rn-clinical-research';

    async function navigate(hash, updateHistory = false) {
      const match = hash.match(mediaPattern);
      let target;
      let focusTarget;

      if (match) {
        const media = document.getElementById(hash.slice(1));
        const gallery = media?.closest('.product-information media-gallery');
        if (!gallery) return;
        const slide = media.closest('slideshow-slide');
        const slideshow = slide?.closest('slideshow-component');
        if (slideshow) {
          // Seed initial navigation before the native gallery finishes upgrading.
          if (!updateHistory) {
            const index = [...slideshow.querySelectorAll('slideshow-slide')].indexOf(slide);
            slideshow.setAttribute('initial-slide', String(index));
          }
          await customElements.whenDefined('slideshow-component');
          await slideshow.select({ id: match[1] }, undefined, { animate: false });
        }
        target = gallery.closest('.product-information__media') || gallery;
        focusTarget = slide || media;
      } else if (hash === researchHash) {
        target = document.getElementById(researchHash.slice(1));
        focusTarget = target?.querySelector('h2') || target;
      }

      if (!target || !focusTarget) return;
      if (updateHistory && location.hash !== hash) history.pushState(history.state, '', hash);
      if (!focusTarget.hasAttribute('tabindex')) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
      }
      focusTarget.focus({ preventScroll: true });
      target.scrollIntoView({
        block: 'start',
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }

    document.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target instanceof Element ? event.target.closest('.product-information a[href^="#"]') : null;
      if (!link || (!mediaPattern.test(link.hash) && link.hash !== researchHash)) return;
      if (!document.getElementById(link.hash.slice(1))) return;
      event.preventDefault();
      navigate(link.hash, true);
    });

    window.addEventListener('hashchange', () => navigate(location.hash));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => navigate(location.hash), { once: true });
    } else {
      navigate(location.hash);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-details-grid"] && !Shopify.designMode) return;
  try {
    
  /* Standalone copy of the PDP ingredient carousel behaviour: the ingredient
     section never loads on the homepage, so the element is defined here too. */
  class RenesiaDetailsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rn-d-track]');
      this.nav = this.querySelector('[data-rn-d-nav]');
      const prev = this.querySelector('[data-rn-d-prev]');
      const next = this.querySelector('[data-rn-d-next]');
      if (!this.track || !this.nav || !prev || !next) return;

      prev.addEventListener('click', () => this.step(-1));
      next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });

      const ro = new ResizeObserver(() => this.sync());
      ro.observe(this.track);
      window.addEventListener('resize', () => this.sync());
      this.sync();
    }

    get slides() { return [...this.track.children]; }

    /* Offsets normalised so the first card sits at 0 — offsetLeft carries the
       rail's bleed, and using it raw leaves every target a gutter out. */
    positions() {
      const slides = this.slides;
      if (!slides.length) return [];
      const base = slides[0].offsetLeft;
      return slides.map((s) => s.offsetLeft - base);
    }

    index() {
      const positions = this.positions();
      const x = this.track.scrollLeft;
      let best = 0;
      let bestDelta = Infinity;
      positions.forEach((p, i) => {
        const d = Math.abs(p - x);
        if (d < bestDelta) { bestDelta = d; best = i; }
      });
      return best;
    }

    step(dir) {
      const positions = this.positions();
      if (!positions.length) return;
      const i = Math.max(0, Math.min(this.index() + dir, positions.length - 1));
      this.track.scrollTo({ left: positions[i], behavior: 'smooth' });
    }

    sync() {
      const overflows = this.track.scrollWidth > this.track.clientWidth + 2;
      this.nav.hidden = !overflows;
      const prev = this.querySelector('[data-rn-d-prev]');
      const next = this.querySelector('[data-rn-d-next]');
      if (!overflows || !prev || !next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      prev.disabled = this.track.scrollLeft <= 2;
      next.disabled = this.track.scrollLeft >= max - 2;
    }
  }
  if (!customElements.get('renesia-details-carousel')) {
    customElements.define('renesia-details-carousel', RenesiaDetailsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-expect"] && !Shopify.designMode) return;
  try {
    
  class RenesiaExpect extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('[data-rn-step]')];
      this.shots = [...this.querySelectorAll('[data-rn-shot]')];

      this.steps.forEach((step) => {
        step.addEventListener('toggle', () => {
          if (!step.open) return;
          // One phase at a time, like the reference.
          this.steps.forEach((other) => { if (other !== step) other.open = false; });
          this.showShot(step.dataset.rnStep);
        });
      });
    }

    showShot(index) {
      this.shots.forEach((s) => { s.hidden = s.dataset.rnShot !== index; });
    }
  }
  if (!customElements.get('renesia-expect')) customElements.define('renesia-expect', RenesiaExpect);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-experts"] && !Shopify.designMode) return;
  try {
    
  class RenesiaExpCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rn-exp-track]');
      this.nav = this.querySelector('[data-rn-exp-nav]');
      const prev = this.querySelector('[data-rn-exp-prev]');
      const next = this.querySelector('[data-rn-exp-next]');

      this.querySelectorAll('[data-rn-exp-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const quote = btn.parentElement.querySelector('[data-rn-exp-quote]');
          const open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (quote) quote.hidden = open;
        });
      });

      if (!this.track || !this.nav) return;
      prev.addEventListener('click', () => this.step(-1));
      next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      const ro = new ResizeObserver(() => this.sync());
      ro.observe(this.track);
      window.addEventListener('resize', () => this.sync());
      this.sync();
    }
    positions() {
      const slides = [...this.track.children];
      if (!slides.length) return [];
      const base = slides[0].offsetLeft;
      return slides.map((s) => s.offsetLeft - base);
    }
    index() {
      const positions = this.positions();
      const x = this.track.scrollLeft;
      let best = 0; let bestDelta = Infinity;
      positions.forEach((p, i) => {
        const d = Math.abs(p - x);
        if (d < bestDelta) { bestDelta = d; best = i; }
      });
      return best;
    }
    step(dir) {
      const positions = this.positions();
      if (!positions.length) return;
      const i = Math.max(0, Math.min(this.index() + dir, positions.length - 1));
      this.track.scrollTo({ left: positions[i], behavior: 'smooth' });
    }
    sync() {
      // The desktop grid never overflows, so the nav hides itself there.
      const overflows = this.track.scrollWidth > this.track.clientWidth + 2;
      this.nav.hidden = !overflows;
      const prev = this.querySelector('[data-rn-exp-prev]');
      const next = this.querySelector('[data-rn-exp-next]');
      if (!overflows || !prev || !next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      prev.disabled = this.track.scrollLeft <= 2;
      next.disabled = this.track.scrollLeft >= max - 2;
    }
  }
  if (!customElements.get('renesia-exp-carousel')) customElements.define('renesia-exp-carousel', RenesiaExpCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-ingredients-cards"] && !Shopify.designMode) return;
  try {
    
  class RenesiaIngCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rn-ing-track]');
      this.nav = this.querySelector('[data-rn-ing-nav]');
      const prev = this.querySelector('[data-rn-ing-prev]');
      const next = this.querySelector('[data-rn-ing-next]');
      if (!this.track || !this.nav) return;

      prev.addEventListener('click', () => this.step(-1));
      next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });

      // Only show the arrows when the track actually overflows, so they never
      // appear on a viewport where every card already fits.
      const ro = new ResizeObserver(() => this.sync());
      ro.observe(this.track);
      if (this.track.firstElementChild) ro.observe(this.track);
      window.addEventListener('resize', () => this.sync());
      this.sync();
    }

    get slides() { return [...this.track.children]; }

    /* Scroll offsets normalised so the first card sits at 0. offsetLeft
       includes the track's bleed padding, so using it raw put every target
       14px out and `next` never advanced. */
    positions() {
      const slides = this.slides;
      if (!slides.length) return [];
      const base = slides[0].offsetLeft;
      return slides.map((s) => s.offsetLeft - base);
    }

    index() {
      const positions = this.positions();
      const x = this.track.scrollLeft;
      let best = 0;
      let bestDelta = Infinity;
      positions.forEach((p, i) => {
        const d = Math.abs(p - x);
        if (d < bestDelta) { bestDelta = d; best = i; }
      });
      return best;
    }

    step(dir) {
      const positions = this.positions();
      if (!positions.length) return;
      const i = Math.max(0, Math.min(this.index() + dir, positions.length - 1));
      this.track.scrollTo({ left: positions[i], behavior: 'smooth' });
    }

    sync() {
      const overflows = this.track.scrollWidth > this.track.clientWidth + 2;
      this.nav.hidden = !overflows;
      const prev = this.querySelector('[data-rn-ing-prev]');
      const next = this.querySelector('[data-rn-ing-next]');
      if (!overflows || !prev || !next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      prev.disabled = this.track.scrollLeft <= 2;
      next.disabled = this.track.scrollLeft >= max - 2;
    }
  }
  if (!customElements.get('renesia-ing-carousel')) customElements.define('renesia-ing-carousel', RenesiaIngCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-studies"] && !Shopify.designMode) return;
  try {
    
  class RenesiaStdCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rn-std-track]');
      this.nav = this.querySelector('[data-rn-std-nav]');
      const prev = this.querySelector('[data-rn-std-prev]');
      const next = this.querySelector('[data-rn-std-next]');
      if (!this.track || !this.nav) return;
      prev.addEventListener('click', () => this.step(-1));
      next.addEventListener('click', () => this.step(1));
      this.settleTimer = 0;
      this.scrollRaf = 0;
      this.track.addEventListener('scroll', () => {
        this.sync();
        // Eager height re-fit the moment the nearest slide changes; the
        // height lives on the rail wrapper, not the scroll container, so
        // this cannot disturb the gesture or the snap.
        if (!this.scrollRaf) this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          if (this.index() !== this.fitIndex) this.fit();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.fit(), 120);
      }, { passive: true });
      this.track.addEventListener('scrollend', () => this.fit(), { passive: true });
      const ro = new ResizeObserver(() => { this.sync(); this.fit(); });
      ro.observe(this.track);
      [...this.track.children].forEach((slide) => ro.observe(slide));
      window.addEventListener('resize', () => { this.sync(); this.fit(); });
      this.sync();
      requestAnimationFrame(() => this.fit());
    }
    positions() {
      const slides = [...this.track.children];
      if (!slides.length) return [];
      const base = slides[0].offsetLeft;
      return slides.map((s) => s.offsetLeft - base);
    }
    index() {
      const positions = this.positions();
      const x = this.track.scrollLeft;
      let best = 0; let bestDelta = Infinity;
      positions.forEach((p, i) => {
        const d = Math.abs(p - x);
        if (d < bestDelta) { bestDelta = d; best = i; }
      });
      return best;
    }
    step(dir) {
      const positions = this.positions();
      if (!positions.length) return;
      const i = Math.max(0, Math.min(this.index() + dir, positions.length - 1));
      this.track.scrollTo({ left: positions[i], behavior: 'smooth' });
    }
    fit() {
      // Mobile-only: the rail height follows the active card.
      const slides = [...this.track.children];
      if (!slides.length) return;
      if (window.matchMedia('(min-width: 750px)').matches) {
        this.style.removeProperty('--rn-std-h');
        this.fitIndex = -1;
        return;
      }
      const i = this.index();
      const active = slides[i];
      if (!active) return;
      this.fitIndex = i;
      const cs = getComputedStyle(this.track);
      const pad = cs.boxSizing === 'border-box'
        ? parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0)
        : 0;
      const h = Math.ceil(active.getBoundingClientRect().height + pad);
      this.style.setProperty('--rn-std-h', h + 'px');
    }
    sync() {
      // Generous threshold: the desktop 3-up fits exactly but rounding can
      // leave a couple of phantom pixels, which must not summon the arrows.
      const overflows = this.track.scrollWidth > this.track.clientWidth + 8;
      this.nav.hidden = !overflows;
      const prev = this.querySelector('[data-rn-std-prev]');
      const next = this.querySelector('[data-rn-std-next]');
      if (!overflows || !prev || !next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      prev.disabled = this.track.scrollLeft <= 2;
      next.disabled = this.track.scrollLeft >= max - 2;
    }
  }
  if (!customElements.get('renesia-std-carousel')) customElements.define('renesia-std-carousel', RenesiaStdCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-testimonials-v2"] && !Shopify.designMode) return;
  try {
    
  class RenesiaTv2Carousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rn-tv2-track]');
      this.nav = this.querySelector('[data-rn-tv2-nav]');
      const prev = this.querySelector('[data-rn-tv2-prev]');
      const next = this.querySelector('[data-rn-tv2-next]');
      if (!this.track || !this.nav) return;
      prev.addEventListener('click', () => this.step(-1));
      next.addEventListener('click', () => this.step(1));
      this.settleTimer = 0;
      this.scrollRaf = 0;
      this.track.addEventListener('scroll', () => {
        this.sync();
        // Re-fit as soon as the nearest slide CHANGES, so the height is
        // already animating while the card glides in. The height lives on
        // the rail wrapper, not the scroll container, so this cannot disturb
        // the gesture or the snap. The settle timeout stays as a backstop.
        if (!this.scrollRaf) this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          if (this.index() !== this.fitIndex) this.fit();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.fit(), 120);
      }, { passive: true });
      this.track.addEventListener('scrollend', () => this.fit(), { passive: true });
      const ro = new ResizeObserver(() => { this.sync(); this.fit(); });
      ro.observe(this.track);
      [...this.track.children].forEach((slide) => ro.observe(slide));
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.fit(), { once: true });
      });
      window.addEventListener('resize', () => { this.sync(); this.fit(); });
      this.sync();
      requestAnimationFrame(() => this.fit());
    }
    positions() {
      const slides = [...this.track.children];
      if (!slides.length) return [];
      const base = slides[0].offsetLeft;
      return slides.map((s) => s.offsetLeft - base);
    }
    index() {
      const positions = this.positions();
      const x = this.track.scrollLeft;
      let best = 0; let bestDelta = Infinity;
      positions.forEach((p, i) => {
        const d = Math.abs(p - x);
        if (d < bestDelta) { bestDelta = d; best = i; }
      });
      return best;
    }
    step(dir) {
      const positions = this.positions();
      if (!positions.length) return;
      const i = Math.max(0, Math.min(this.index() + dir, positions.length - 1));
      this.track.scrollTo({ left: positions[i], behavior: 'smooth' });
    }
    fit() {
      // Mobile-only: the rail height follows the active card. Desktop rows
      // stay stretched to equal height.
      const slides = [...this.track.children];
      if (!slides.length) return;
      if (window.matchMedia('(min-width: 750px)').matches) {
        this.style.removeProperty('--rn-tv2-h');
        this.fitIndex = -1;
        return;
      }
      const i = this.index();
      const active = slides[i];
      if (!active) return;
      this.fitIndex = i;
      const cs = getComputedStyle(this.track);
      const pad = cs.boxSizing === 'border-box'
        ? parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0)
        : 0;
      const h = Math.ceil(active.getBoundingClientRect().height + pad);
      this.style.setProperty('--rn-tv2-h', h + 'px');
    }
    sync() {
      const overflows = this.track.scrollWidth > this.track.clientWidth + 2;
      this.nav.hidden = !overflows;
      const prev = this.querySelector('[data-rn-tv2-prev]');
      const next = this.querySelector('[data-rn-tv2-next]');
      if (!overflows || !prev || !next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      prev.disabled = this.track.scrollLeft <= 2;
      next.disabled = this.track.scrollLeft >= max - 2;
    }
  }
  if (!customElements.get('renesia-tv2-carousel')) customElements.define('renesia-tv2-carousel', RenesiaTv2Carousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-transformations"] && !Shopify.designMode) return;
  try {
    
  class RenesiaCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rn-track]');
      this.dots = [...this.querySelectorAll('[data-rn-dot]')];
      this.slides = [...this.track?.children || []];
      if (!this.track) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const i = parseInt(dot.dataset.rnDot, 10);
          this.goTo(i);
        });
      });

      this.dragging = false;
      this.snapping = false;
      this.scrollRaf = 0;
      this.settleTimer = 0;
      this.snapTimer = 0;

      const beginDrag = () => {
        this.dragging = true;
        this.snapping = false;
        clearTimeout(this.settleTimer);
        clearTimeout(this.snapTimer);
      };
      const endDrag = () => {
        this.dragging = false;
        this.scheduleSettle();
      };
      this.track.addEventListener('pointerdown', beginDrag, { passive: true });
      this.track.addEventListener('pointerup', endDrag, { passive: true });
      this.track.addEventListener('pointercancel', endDrag, { passive: true });

      // Keep dots responsive during the gesture, but keep the rail height
      // stable. Changing height while momentum is still running destabilises
      // the browser's native snap calculation and can leave the rail between
      // slides.
      this.track.addEventListener(
        'scroll',
        () => {
          if (!this.scrollRaf) this.scrollRaf = requestAnimationFrame(() => {
            this.scrollRaf = 0;
            this.updateDots(this.nearestIndex());
          });
          if (!this.dragging && !this.snapping) this.scheduleSettle();
        },
        { passive: true }
      );
      this.track.addEventListener('scrollend', () => this.settle(), { passive: true });

      // Re-measure only after the rail has settled.
      const ro = new ResizeObserver(() => {
        if (!this.dragging && !this.snapping) this.fit(this.slides[this.nearestIndex()]);
      });
      this.slides.forEach((s) => ro.observe(s));
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.settle('auto'), { once: true });
      });
      requestAnimationFrame(() => this.settle('auto'));
      window.addEventListener('resize', () => this.settle('auto'));
    }

    positions() {
      const base = this.slides[0]?.offsetLeft || 0;
      return this.slides.map((slide) => slide.offsetLeft - base);
    }

    nearestIndex() {
      const positions = this.positions();
      let best = 0;
      let delta = Infinity;
      positions.forEach((position, index) => {
        const candidate = Math.abs(position - this.track.scrollLeft);
        if (candidate < delta) {
          delta = candidate;
          best = index;
        }
      });
      return best;
    }

    updateDots(i) {
      this.dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
    }

    scheduleSettle() {
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), 140);
    }

    settle(behavior = 'smooth') {
      if (this.dragging || this.snapping || !this.slides.length) return;
      const i = this.nearestIndex();
      const target = this.positions()[i];
      this.updateDots(i);
      if (Math.abs(this.track.scrollLeft - target) <= 1 || behavior === 'auto') {
        this.track.scrollTo({ left: target, behavior: 'auto' });
        this.fit(this.slides[i]);
        return;
      }
      this.goTo(i, behavior);
    }

    goTo(i, behavior = 'smooth') {
      const slide = this.slides[i];
      const target = this.positions()[i];
      if (!slide || target == null) return;
      this.snapping = behavior !== 'auto';
      this.updateDots(i);
      this.track.scrollTo({ left: target, behavior });
      clearTimeout(this.snapTimer);
      this.snapTimer = setTimeout(() => {
        // Pin the final pixel. Fractional momentum positions are what produce
        // the half-slide state on touch devices.
        this.track.scrollLeft = target;
        this.snapping = false;
        this.updateDots(i);
        this.fit(slide);
      }, behavior === 'auto' ? 0 : 360);
    }

    fit(slide) {
      const active = slide;
      if (!active) return;
      // Measure the children rather than the slide box, because the slide sits
      // in a clipped track and its own scrollHeight echoes the applied height.
      // Take the union of their boxes, not the sum: stacked mobile children
      // add up naturally, while the two-column desktop slide resolves to its
      // taller column instead of image plus quote added together.
      const kids = [...active.children];
      if (!kids.length) {
        this.track.style.setProperty('--rn-tr-h', active.scrollHeight + 'px');
        return;
      }
      let top = Infinity;
      let bottom = -Infinity;
      kids.forEach((k) => {
        const box = k.getBoundingClientRect();
        const cs = getComputedStyle(k);
        top = Math.min(top, box.top - parseFloat(cs.marginTop || 0));
        bottom = Math.max(bottom, box.bottom + parseFloat(cs.marginBottom || 0));
      });
      this.track.style.setProperty('--rn-tr-h', Math.ceil(bottom - top) + 'px');
    }

  }
  if (!customElements.get('renesia-carousel')) customElements.define('renesia-carousel', RenesiaCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renesia-video-proof"] && !Shopify.designMode) return;
  try {
    
  class RenesiaVideoProof extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rn-vp-track]');
      this.nav = this.querySelector('[data-rn-vp-nav]');
      if (!this.track) return;

      this.querySelectorAll('[data-rn-vp-play]').forEach((button) => {
        button.addEventListener('click', () => this.play(button));
      });

      // A clip that reaches the end hands the card back to its poster.
      this.videos.forEach((video) => {
        video.addEventListener('ended', () => this.reset(video));
      });

      this.warmWhenIdle();

      const prev = this.querySelector('[data-rn-vp-prev]');
      const next = this.querySelector('[data-rn-vp-next]');
      if (prev && next && this.nav) {
        prev.addEventListener('click', () => this.step(-1));
        next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.sync(), { passive: true });
        new ResizeObserver(() => this.sync()).observe(this.track);
        window.addEventListener('resize', () => this.sync());
        this.sync();
      }
    }

    get slides() { return [...this.track.children]; }
    get videos() { return [...this.querySelectorAll('[data-rn-vp-video]')]; }

    /* The markup ships preload="none" so no video byte competes with LCP.
       Once the page has loaded and the main thread is idle, the section warms
       ahead of the reader: the first card buffers fully so it plays instantly,
       every other card takes metadata only and is upgraded on hover, focus or
       touch, which lands a few hundred ms before the click. Exactly one clip is
       ever fetched automatically, so adding more videos to this section costs
       nothing extra. Data-saver and 2G never go past metadata. */
    warmWhenIdle() {
      const videos = this.videos;
      if (!videos.length || !('IntersectionObserver' in window)) return;

      const link = navigator.connection || {};
      const frugal = link.saveData === true || /(^|-)2g$/.test(link.effectiveType || '');

      const warm = (video, full) => {
        if (video.dataset.rnVpWarm === 'auto') return;
        // Never re-load a clip someone is already watching: load() would rewind it.
        if (!video.paused || video.currentTime > 0) return;
        if (full && !frugal) {
          video.preload = 'auto';
          video.dataset.rnVpWarm = 'auto';
          video.load();
        } else if (!video.dataset.rnVpWarm) {
          video.preload = 'metadata';
          video.dataset.rnVpWarm = 'metadata';
        }
      };

      const start = () => {
        const approaching = new IntersectionObserver((entries, observer) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          warm(videos[0], true);
          videos.slice(1).forEach((video) => warm(video, false));
        }, { rootMargin: '200% 0px' });
        approaching.observe(this);

        // Intent, not visibility: buffering every on-screen card would cost the
        // whole section at once on a desktop rail showing five at a time.
        videos.forEach((video) => {
          const card = video.closest('.renesia-vp__card') || video.parentElement;
          ['pointerenter', 'touchstart', 'focusin'].forEach((event) => {
            card.addEventListener(event, () => warm(video, true), { once: true, passive: true });
          });
        });
      };

      const whenIdle = () => (window.requestIdleCallback || ((fn) => setTimeout(fn, 200)))(start, { timeout: 3000 });
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true });
    }

    play(button) {
      const video = button.parentElement.querySelector('[data-rn-vp-video]');
      if (!video) return;
      // Only ever one clip at a time, so a scrolled-past video cannot keep talking.
      this.videos.forEach((other) => { if (other !== video) this.reset(other); });
      video.setAttribute('controls', '');
      button.hidden = true;
      const caption = button.parentElement.querySelector('.renesia-vp__caption');
      if (caption) caption.hidden = true;
      const played = video.play();
      if (played && played.catch) played.catch(() => this.reset(video));
    }

    reset(video) {
      video.pause();
      video.removeAttribute('controls');
      const frame = video.parentElement;
      const button = frame.querySelector('[data-rn-vp-play]');
      const caption = frame.querySelector('.renesia-vp__caption');
      if (button) button.hidden = false;
      if (caption) caption.hidden = false;
    }

    /* Offsets normalised so the first card sits at 0 - the slide padding is
       part of offsetLeft and would otherwise bias every target. */
    positions() {
      const slides = this.slides;
      if (!slides.length) return [];
      const base = slides[0].offsetLeft;
      return slides.map((slide) => slide.offsetLeft - base);
    }

    index() {
      const positions = this.positions();
      const x = this.track.scrollLeft;
      let best = 0;
      let bestDelta = Infinity;
      positions.forEach((p, i) => {
        const d = Math.abs(p - x);
        if (d < bestDelta) { bestDelta = d; best = i; }
      });
      return best;
    }

    step(dir) {
      const positions = this.positions();
      if (!positions.length) return;
      const i = Math.max(0, Math.min(this.index() + dir, positions.length - 1));
      this.track.scrollTo({ left: positions[i], behavior: 'smooth' });
    }

    sync() {
      const overflows = this.track.scrollWidth > this.track.clientWidth + 2;
      this.nav.hidden = !overflows;
      const prev = this.querySelector('[data-rn-vp-prev]');
      const next = this.querySelector('[data-rn-vp-next]');
      if (!overflows || !prev || !next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      prev.disabled = this.track.scrollLeft <= 2;
      next.disabled = this.track.scrollLeft >= max - 2;
    }
  }
  if (!customElements.get('renesia-video-proof')) {
    customElements.define('renesia-video-proof', RenesiaVideoProof);
  }

  } catch(e) { console.error(e); }
})();
})();
